import { numericSpace } from '@ardoq/design-tokens';
import { HEADER4_LINE_HEIGHT_IN_PIXELS } from '@ardoq/typography';

export const RESULT_LABEL_GAP = numericSpace.medium;
export const MAX_RESULT_LABEL_LINES = 3;

type ResultLabelSpace = {
  contentHeight: number | undefined;
  numberHeight: number | undefined;
};

export const getResultLabelLineCount = ({
  contentHeight,
  numberHeight,
}: ResultLabelSpace): number => {
  if (contentHeight === undefined || numberHeight === undefined) {
    return 1;
  }
  const availableHeight = contentHeight - numberHeight - RESULT_LABEL_GAP;
  const fittingLines = Math.floor(
    availableHeight / HEADER4_LINE_HEIGHT_IN_PIXELS
  );
  return Math.min(MAX_RESULT_LABEL_LINES, Math.max(1, fittingLines));
};
